import "./nav-profile.css";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { FiLogOut } from "react-icons/fi";
import { Link } from "react-router-dom";
import { logout } from "../../helperFunctions/cookie";

const NavProfile = () => {
  const [visible, setVisibility] = useState(false);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const navigate = useNavigate();

  const logoutHandler = () => {
    logout();
    navigate("/signin");
  };

  return (
    <div
      onMouseEnter={() => setVisibility(true)}
      onMouseLeave={() => setVisibility(false)}
    >
      <img
        id="profile-img"
        alt="profile"
        src={`https://api.dicebear.com/8.x/initials/svg?seed=${
          user.firstName[0] + user.lastName[0]
        }`}
      />
      {visible && (
        <div id="profile-dropdown-list">
          <Link to="/settings">
            <h3 className="nav-list-item">Profile</h3>
          </Link>
          {/* <h3 className="nav-list-item">Members</h3>
          <h3 className="nav-list-item">Settings</h3> */}
          <button className="logout-btn" onClick={logoutHandler}>
            {<FiLogOut id="logout-icon" />} Log Out
          </button>
        </div>
      )}
    </div>
  );
};

export default NavProfile;
